// App Imports
import {IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import params from '../../../setup/config/params'
import List from '../List'
import creategoals from '../Creategoals'
import UpdateGoals from '../UpdateGoals'
import createrewards from '../Createrewards'
import UpdateRewards from '../UpdateRewards'
import LeaderboardDetail from '../Leaderboard/Detail'
import createEvents from '../CreateEvents'
import UpdateEvents from '../UpdateEvents'

import { defaultImage } from '../../common/Sidebar';


// Image
export function getImageSource(image = defaultImage) {
  return `${ IMAGE_SOURCE_PATH }${ image }`
}

// Rewards and Goals routes
const routes = {
  listAllTabs: {
    path: '/goals',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canView",
  },
  listGoals: {
    path: '/goals',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canView",
  },
  creategoals: {
    path: '/goals/create',
    component: creategoals,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canCreate",
  },
  editGoals: {
    path: (goalId = ':goalId') => `/goals/edit/${goalId}`,
    component: UpdateGoals,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canEdit",
  },
  listPoints: {
    path: '/points',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canView",
  },
  listRewards: {
    path: '/rewards',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canView",
  },
  createRewards: {
    path: '/rewards/create',
    component: createrewards,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canCreate",
  },
  editRewards: {
    path: (rewardsId = ':rewardsId') => `/rewards/edit/${rewardsId}`,
    component: UpdateRewards,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canEdit",
  },
  listLeaderboard: {
    path: '/leaderboard',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canView",
  },
  LeaderBoardDetails: {
    path: (_id = ':_id') => `/leaderboard/detail/${_id}`,
    component: LeaderboardDetail,
    auth: true,
    role: [params.user.roles.admin.key, params.user.roles.vendor.key],
    module: "marketing",
    subModule: "reward",
    action: "canView",
  },
  createEvents: {
    path: '/events/create',
    component: createEvents,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canCreate",
  },
  editEvents: {
    path: (eventId = ':eventId') => `/events/update/${eventId}`,
    component: UpdateEvents,
    auth: true,
    role: params.user.roles.admin.key,
    module: "marketing",
    subModule: "reward",
    action: "canEdit",
  },
};

export default routes;
